import { render, staticRenderFns } from "./SendToVendorModal.vue?vue&type=template&id=9fdf6efc&scoped=true&"
import script from "./SendToVendorModal.vue?vue&type=script&lang=js&"
export * from "./SendToVendorModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fdf6efc",
  null
  
)

export default component.exports